import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

export const TRANSFORMER = graphql.transformers.IN.enumeration<
  ents.extra.space.Report.Configuration.RoomSupportingInformation.SortBy,
  graphql.schema.SpaceReportRoomSupportingInformationSortBy
>({
  [ents.extra.space.Report.Configuration.RoomSupportingInformation.SortBy
    .Building]:
    graphql.schema.SpaceReportRoomSupportingInformationSortBy.Building,
  [ents.extra.space.Report.Configuration.RoomSupportingInformation.SortBy
    .ResponsiblePerson]:
    graphql.schema.SpaceReportRoomSupportingInformationSortBy.ResponsiblePerson,
})
